<template>
    <div class="main-wrapper">
        <div class="main-wrapper-table">
            <el-scrollbar class="main-wrapper-scrollbar">
                <el-table :data="goodsReleaseList" class="customTable goods-text-table" style="width: 100%; flex: 1; margin-top: 20px" height="1%">
                    <el-table-column prop="content" label="考试内容" width="200px"></el-table-column>
                    <el-table-column label="学生提交答案" align="left" width="380px">
                        <template slot-scope="scope">
                            <div class="answer">
                                <img :src="scope.row.img" alt="">
                                <span class="text">{{scope.row.name}}</span>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="search_num" label="搜索人数" align="center"></el-table-column>
                    <el-table-column prop="click_rate" label="点击率" align="center"></el-table-column>
                    <el-table-column prop="stu_click_num" label="学生点击量" align="center"></el-table-column>
                    <el-table-column prop="full_click_num" label="满分点击量" align="center"></el-table-column>
                    <el-table-column prop="score" label="得分（15分）" align="center" width="150px"></el-table-column>
                </el-table>
                <el-table :data="goodsShootList" class="customTable" style="width: 100%; flex: 1; margin-top: 20px" height="100%">
                    <el-table-column prop="content" label="考试内容"></el-table-column>
                    <el-table-column prop="model" label="考试模块"></el-table-column>
                    <el-table-column label="学生提交答案" align="center">
                        <template slot-scope="scope">
                            <div class="link-box">
                                <el-link type="success" :underline="false" @click="viewDetailGoods(scope.row)">查看详情</el-link>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="正确答案" align="center">
                        <template slot-scope="scope">
                            <div class="link-box">
                                <el-link type="success" :underline="false" @click="viewDetailGoods(scope.row)">查看详情</el-link>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="score" label="得分（15分）" align="center"></el-table-column>
                </el-table>
                <!--S 移动-->
                <el-table :data="goodsMoveList" class="customTable goods-text-table" style="width: 100%; flex: 1; margin-top: 20px" height="1%">
                    <el-table-column prop="content" label="考试内容" width="320px"></el-table-column>
                    <el-table-column label="学生提交答案" align="left" width="380px">
                        <template slot-scope="scope">
                            <div class="answer">
                                <img :src="scope.row.img" alt="">
                                <span class="text">{{scope.row.name}}</span>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="search_num" label="搜索人数" align="center"></el-table-column>
                    <el-table-column prop="click_rate" label="点击率" align="center"></el-table-column>
                    <el-table-column prop="stu_click_num" label="学生点击量" align="center"></el-table-column>
                    <el-table-column prop="full_click_num" label="满分点击量" align="center"></el-table-column>
                    <el-table-column prop="score" label="得分（15分）" align="center" width="150px"></el-table-column>
                </el-table>
                <el-table :data="goodsMoveShootList" class="customTable" style="width: 100%; flex: 1; margin-top: 20px" height="100%">
                    <el-table-column prop="content" label="考试内容"></el-table-column>
                    <el-table-column prop="model" label="考试模块"></el-table-column>
                    <el-table-column label="学生提交答案" align="center">
                        <template slot-scope="scope">
                            <div class="link-box">
                                <el-link type="success" :underline="false" @click="viewMoveDetail(scope.row)">查看详情</el-link>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="正确答案" align="center">
                        <template slot-scope="scope">
                            <div class="link-box">
                                <el-link type="success" :underline="false" @click="viewMoveDetail(scope.row)">查看详情</el-link>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="score" label="得分（15分）" align="center"></el-table-column>
                </el-table>
                <!--E 移动-->
                <el-table :data="goodsOrderList" class="customTable goods-text-table" style="width: 100%; flex: 1; margin-top: 20px" height="1%">
                    <el-table-column prop="content" label="考试内容" width="360"></el-table-column>
                    <el-table-column prop="orderNum"  label="订单编号" align="center" ></el-table-column>
                    <el-table-column prop="scoring_operation"  label="得分操作" align="center" ></el-table-column>
                    <el-table-column label="学生提交答案" align="center" >
                        <template slot-scope="scope">
                            <div class="link-box">
                                <el-link type="success" :underline="false" @click="viewOrderDetail(scope.row)">查看详情</el-link>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="正确答案" align="center" >
                        <template slot-scope="scope">
                            <div class="link-box">
                                <el-link type="success" :underline="false" @click="viewOrderDetail(scope.row)">查看详情</el-link>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="score" label="得分（15分）" align="center" width="150px"></el-table-column>
                </el-table>
            </el-scrollbar>
        </div>
        <!--S 网店管理弹窗-->
        <!--S 修改快递单号-->
        <el-dialog :close-on-click-modal="false" :close-on-press-escape="false" :title="modifyOrderTitle"
                   custom-class="green-dialog02" :visible.sync="modifyOrderDialog" width="500px">
            <el-form :model="modifyOrderForm" ref="modifyOrderForm" label-position="right" label-width="100px">
                <el-form-item label="订单号:"  prop="order_no">
                    <div class="order-no-title">{{modifyOrderForm.order_no}}</div>
                </el-form-item>
                <div v-if="this.scoring_operation ==='出库'||this.scoring_operation ==='修改快递单号'">
                    <el-form-item label="快递" prop="delivery_mode">
                        <el-input v-model="modifyOrderForm.delivery_mode" autocomplete="off" style="width:340px" readonly></el-input>
                    </el-form-item>
                    <el-form-item label="单号" prop="logistics_number">
                        <el-input v-model="modifyOrderForm.logistics_number"  autocomplete="off" style="width:340px" readonly></el-input>
                    </el-form-item>
                </div>
                <el-form-item label="出库情况" prop="operation" v-if="this.scoring_operation ==='退款审核（通过）'||this.scoring_operation ==='退款审核（驳回）'">
                    <el-input v-model="modifyOrderForm.operation" autocomplete="off" style="width:340px" readonly></el-input>
                </el-form-item>
                <el-form-item label="驳回原因" prop="reasons_rejection" v-if="this.scoring_operation ==='退款审核（驳回）'">
                    <el-input v-model="modifyOrderForm.reasons_rejection"  autocomplete="off" style="width:340px" readonly></el-input>
                </el-form-item>
                <el-form-item label="审核原因" prop="operation" v-if="this.scoring_operation ==='换货审核（通过）'||this.scoring_operation ==='退货审核（通过）'||
                this.scoring_operation ==='换货审核（驳回）'||this.scoring_operation ==='退货审核（驳回）'">
                    <el-input v-model="modifyOrderForm.audit_reasons" autocomplete="off" style="width:340px" readonly></el-input>
                </el-form-item>
                <el-form-item label="驳回原因" prop="reasons_rejection" v-if="this.scoring_operation ==='换货审核（驳回）'||this.scoring_operation ==='退货审核（驳回）'">
                    <el-input v-model="modifyOrderForm.reasons_rejection"  autocomplete="off" style="width:340px" readonly></el-input>
                </el-form-item>
            </el-form>
            <div class="dialog-footer">
                <el-button @click="modifyOrderDialog = false">取 消</el-button>
                <el-button style="margin-left: 30px" type="primary" @click="addOrderBtn()">确 定</el-button>
            </div>
        </el-dialog>
        <!--E 修改快递单号-->
        <!--E 网店管理弹窗-->
    </div>
</template>

<script>
    export default {
        name: "StoreManage",
        data() {
            return {
                //网店管理商品发布
                goodsReleaseList: [
                    {
                        content: '网店商品发布与管理',
                        img: require('../../../../assets/images/user_img.png'),
                        name: '男鞋跑步鞋轻便减震透气休闲运动鞋671832270-3曜石黑/361度白男鞋跑步鞋轻便减震透气休闲运动鞋671832270-3曜石黑/361度白',
                        search_num: '1000',
                        click_rate: '30%',
                        stu_click_num: '3000',
                        full_click_num: '300',
                        score: '8'
                    },
                    {
                        content: '',
                        img: require('../../../../assets/images/user_img.png'),
                        name: '男鞋跑步鞋轻便减震透气休闲运动鞋671832270-3曜石黑/361度白',
                        search_num: '1000',
                        click_rate: '30%',
                        stu_click_num: '3000',
                        full_click_num: '300',
                        score: '8'
                    }, {
                        content: '',
                        img: require('../../../../assets/images/user_img.png'),
                        name: '男鞋跑步鞋轻便减震透气休闲运动鞋671832270-3曜石黑/361度白',
                        search_num: '1000',
                        click_rate: '30%',
                        stu_click_num: '3000',
                        full_click_num: '300',
                        score: '8'
                    }, {
                        content: '',
                        img: require('../../../../assets/images/user_img.png'),
                        name: '男鞋跑步鞋轻便减震透气休闲运动鞋671832270-3曜石黑/361度白',
                        search_num: '1000',
                        click_rate: '30%',
                        stu_click_num: '3000',
                        full_click_num: '300',
                        score: '8'
                    }, {
                        content: '',
                        img: require('../../../../assets/images/user_img.png'),
                        name: '男鞋跑步鞋轻便减震透气休闲运动鞋671832270-3曜石黑/361度白',
                        search_num: '1000',
                        click_rate: '30%',
                        stu_click_num: '3000',
                        full_click_num: '300',
                        score: '8'
                    },

                ],
                //网店管理商品发布
                goodsShootList: [
                    {
                        content: '网店商品发布与管理',
                        model:'创建运费模块',
                        score: '8'
                    }
                ],
                //移动平台商品发布与管理
                goodsMoveList: [
                    {
                        content: '移动平台商品发布与管理',
                        img: require('../../../../assets/images/user_img.png'),
                        name: '男鞋跑步鞋轻便减震透气休闲运动鞋671832270-3曜石黑/361度白',
                        search_num: '1000',
                        click_rate: '30%',
                        stu_click_num: '3000',
                        full_click_num: '300',
                        score: '8'
                    }, {
                        content: '',
                        img: require('../../../../assets/images/user_img.png'),
                        name: '男鞋跑步鞋轻便减震透气休闲运动鞋671832270-3曜石黑/361度白',
                        search_num: '1000',
                        click_rate: '30%',
                        stu_click_num: '3000',
                        full_click_num: '300',
                        score: '8'
                    }, {
                        content: '',
                        img: require('../../../../assets/images/user_img.png'),
                        name: '男鞋跑步鞋轻便减震透气休闲运动鞋671832270-3曜石黑/361度白',
                        search_num: '1000',
                        click_rate: '30%',
                        stu_click_num: '3000',
                        full_click_num: '300',
                        score: '8'
                    }, {
                        content: '',
                        img: require('../../../../assets/images/user_img.png'),
                        name: '男鞋跑步鞋轻便减震透气休闲运动鞋671832270-3曜石黑/361度白',
                        search_num: '1000',
                        click_rate: '30%',
                        stu_click_num: '3000',
                        full_click_num: '300',
                        score: '8'
                    },
                ],
                goodsMoveShootList:[
                    {
                        content: '移动平台商品发布与管理',
                        model:'创建运费模块',
                        score: '8'
                    }
                ],
                // 网店订单管理
                goodsOrderList:[
                    {
                        id:1,
                        content: '网店订单管理设置',
                        orderNum:'123456789787',
                        scoring_operation: '出库',
                        score: '8'
                    },
                    {
                        id:2,
                        content: '',
                        orderNum:'123456789787',
                        scoring_operation: '修改快递单号',
                        score: '8'
                    },
                    {
                        id:3,
                        content: '',
                        orderNum:'123456789787',
                        scoring_operation: '退款审核（通过）',
                        score: '8'
                    },
                    {
                        id:4,
                        content: '',
                        orderNum:'123456789787',
                        scoring_operation: '退款审核（驳回）',
                        score: '8'
                    },

                    {
                        id:5,
                        content: '',
                        orderNum:'123456789787',
                        scoring_operation: '退货审核（驳回）',
                        score: '8'
                    },
                    {
                        id:6,
                        content: '',
                        orderNum:'123456789787',
                        scoring_operation: '退货审核（通过）',
                        score: '8'
                    },
                    {
                        id:7,
                        content: '',
                        orderNum:'123456789787',
                        scoring_operation: '换货审核（通过）',
                        score: '8'
                    },
                    {
                        id:8,
                        content: '',
                        orderNum:'123456789787',
                        scoring_operation: '换货审核（驳回）',
                        score: '8'
                    },
                ],
                //网店管理文字弹窗
                modifyOrderTitle:'',
                //修改快递单号弹窗
                modifyOrderDialog:false,
                modifyOrderForm:{
                    order_no:'123456789870',
                    delivery_mode:'中通快递',
                    logistics_number:'1155555555',
                    audit_reasons:'产品质量',
                    reasons_rejection:'1155555555',
                    operation:'未出库',

                },
                scoring_operation:'',
            }
        },
        methods: {
            //查看详情网店商品发布与管理
            viewDetailGoods() {
                let routeDate = this.$router.resolve({
                    path: '/examCenter/examData/freightDetail',
                    // query:{
                    //     id:row.certificate_id
                    // }
                })
                window.open(routeDate.href,'_blank')

            },
            // 移动
            viewMoveDetail(){
                let routeDate = this.$router.resolve({
                    path: '/examCenter/examData/freightDetail',
                    // query:{
                    //     id:row.certificate_id
                    // }
                })
                window.open(routeDate.href,'_blank')
            },
            //订单
            viewOrderDetail(row) {
                console.log(row,'row')
                this.modifyOrderDialog = true;
                switch (row.id) {
                    case 1:
                        this.scoring_operation = '出库';
                        this.modifyOrderTitle = '出库'
                        break;
                    case 2:
                        this.scoring_operation = '修改快递单号';
                        this.modifyOrderTitle = '修改快递单号'
                        break;
                    case 3:
                        this.scoring_operation = '退款审核（通过）';
                        this.modifyOrderTitle = '退款审核单审核'
                        break;
                    case 4:
                        this.scoring_operation = '退款审核（驳回）';
                        this.modifyOrderTitle = '退款审核单审核'
                        break;
                    case 5:
                        this.scoring_operation = '退货审核（驳回）';
                        this.modifyOrderTitle = '退货审核'
                        break;
                    case 6:
                        this.scoring_operation = '退货审核（通过）';
                        this.modifyOrderTitle = '退货审核'
                        break;
                    case 7:
                        this.scoring_operation = '换货审核（通过）';
                        this.modifyOrderTitle = '换货审核'
                        break;
                    case 8:
                        this.scoring_operation = '换货审核（驳回）';
                        this.modifyOrderTitle = '换货审核'
                        break;
                }
            },
            // 修改快递单号确定事件
            addOrderBtn(){
                this.modifyOrderDialog = false;
            },
            // 退款单审核确定事件
            refundOrderBtn(){
                this.refundOrderDialog = false;
            },

        }
    }
</script>

<style scoped lang="scss">
    .main-wrapper {
        display: flex;
        flex-direction: column;
        height: 100%;
        margin: 0 20px 20px 20px;
        .main-wrapper-table{
            display: flex;
            flex-direction: column;
            height: 100%;
            .main-wrapper-scrollbar{
                height: 100%;
                ::v-deep .el-scrollbar__wrap {
                    overflow-x: hidden;
                }
            }
        }
        .goods-text-table {
            .answer {
                display: flex;
                align-items: center;
                img {
                    width: 80px;
                    height: 80px;
                    margin-right: 15px;
                }
                .text {
                    flex: 1;
                    width: 1%;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 2;
                    overflow: hidden;
                }
            }
        }
        .dialog-footer{
            text-align: center;
            margin-top: 20px;
        }
    }
</style>